let defaultNode: HTMLElement | null = null;

export const setDefaultNode = (node: HTMLElement | null): void => {
  defaultNode = node;
};

export const getDefaultNode = (): HTMLElement => {
  return defaultNode || document.body;
};
